import React, { ReactNode, useMemo, useState } from 'react';
import { BrukerinfoDto } from '../api/generated/praksissted-generated-api';

export interface PsaUserStore {
  psaUser: BrukerinfoDto | undefined;
  setPsaUser: (user: BrukerinfoDto) => void;
}

export const PsaUserContext = React.createContext<PsaUserStore>({
  psaUser: undefined,
  setPsaUser: () => {},
});

export const PsaUserProvider: React.FC<
  React.PropsWithChildren<{ children: ReactNode }>
> = ({ children }) => {
  const [psaUser, setPsaUser] = useState<BrukerinfoDto | undefined>();

  const userStore: PsaUserStore = useMemo(
    () => ({
      psaUser,
      setPsaUser,
    }),
    [psaUser],
  );

  return (
    <PsaUserContext.Provider value={userStore}>
      {children}
    </PsaUserContext.Provider>
  );
};
